<div class="cf-work-sheet-wrapper">
  <div class="cf-work-sheet-container">
    <div class="cf-work-sheet-container-header">
      <div class="cf-work-sheet-container-header-left">
        <button mat-button title="Refresh" class="button-text stroked-btn transparent-btn" (click)="refresh('LEFT-MIDDLE')">
            <i class="fa-regular fa-arrows-rotate"></i>
        </button>
      </div>
      <div class="cf-work-sheet-container-header-middle">
        <h3>Cash Flow Work Sheet</h3>
      </div>
      <div class="cf-work-sheet-container-header-right">
      </div>
    </div>
    <div class="cf-work-sheet-container-body">
      <div class="cf-work-sheet-container-body-top">
        <mat-radio-group class="radiogroup">
          <ng-container *ngFor="let y of mainYears; let i = index">
            <mat-radio-button value="{{y.year}}" (change)="getYearWiseData($event.value, i)"
                              [checked]="yearId == i ? 'true' : 'false'">
              {{y.year}}
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </div>
      <div class="cf-work-sheet-container-body-details">
        <ng-container *ngIf="isDataLoaded">
          <div class="cf-work-sheet-container-body-details-left">
            <div class="cf-work-sheet-container-body-details-left-empty-header">
              <p class="ellipse no-marg"></p>
            </div>
            <div class="cf-work-sheet-container-body-details-left-year">
              <ng-container>
                <div class="year-first flex-box-vc-hr">
                  <p class="ellipse" title="{{currentYear}}">{{currentYear}}</p>
                </div>
                <div class="year-second flex-box-vc-hr">
                  <p class="ellipse" title="{{previousYear}}">{{previousYear}}</p>
                </div>
              </ng-container>
            </div>
            <div class="cf-work-sheet-container-body-details-left-details">
              <div class="ul-class">
                <ul class="cust-items">
                  <li *ngFor="let cashFlowLeft of cashFlowLeftData; index as i;">
                    <!-- Header Item -->
                    <div class="header">
                      <div class="heading">
                        <p class="ellipse no-marg" title="{{cashFlowLeft.cashflowtype}}">
                          {{cashFlowLeft.cashflowtype}}
                        </p>
                      </div>
                      <div class="buttons" (click)="activeRow(cashFlowLeft.cashflowtypeid, 'ADD', 0)">
                        <i class="fa-solid fa-plus"></i>
                      </div>
                    </div>
                    <ul class="cust-items child-ul">
                      <!-- Old row -->
                      <li *ngFor="let old of cashFlowLeft.oldrows">
                        <div class="left-child-row">
                          <div class="status">
                            <span class="col-cf-status">
                            </span>
                          </div>
                          <div class="hover-items"></div>
                          <div class="desc" title="{{old.cashflowlineitem}}">
                            <p class="ellipse no-marg">{{old.cashflowlineitem}}</p>
                          </div>
                          <div class="amount flex-box-vc-hr"
                               title="{{(old.amount == null || old.amount == '0' || old.amount == '0.00') ? '-' : old.amount}}">
                            <p class="ellipse no-marg">
                              {{(old.amount == null || old.amount == '0' || old.amount == '0.00') ? '-' : old.amount}}
                            </p>
                          </div>
                        </div>
                      </li>
                      <!-- New row-->
                      <li *ngFor="let new of cashFlowLeft.newrows; trackBy: trackByFn">
                        <div class="left-child-row">
                          <div class="status">
                            <span class="col-cf-status">
                              <span class="sts-label">NEW</span>
                            </span>
                          </div>
                          <div class="hover-items">
                            <button mat-icon-button class="more-btn" [matMenuTriggerFor]="cfmenu" aria-label=""
                                    #t="matMenuTrigger">
                                    <i class="fa-regular fa-ellipsis-vertical more-actions"></i>
                            </button>
                            <mat-menu #cfmenu="matMenu" #afterMenu="matMenu" xPosition="after">
                              <button mat-menu-item
                                      (click)="activeRow(cashFlowLeft.cashflowtypeid, 'EDIT', new.addcashflowid, new.cashflowlineitem);">
                                      <i class="fa-regular fa-pen"></i>
                                <span>Edit</span>
                              </button>
                              <button mat-menu-item
                                      (click)="confirm('DELETE', new.addcashflowid, new.cashflowlineitem);">
                                      <i class="fa-regular fa-trash-can"></i>
                                <span>Delete</span>
                              </button>
                            </mat-menu>
                          </div>
                          <ng-container *ngIf="isEditLeftSideRow && cashFlowLeft.cashflowtypeid === leftSideCashFlowTypeId && new.addcashflowid === addCashFlowId; else notEditable">
                            <div class="desc">
                              <div class="sheet-editable">
                                <mat-form-field class="sheet-form-field">
                                  <input matInput class="sheet-textfield" [(ngModel)]="cashLineItemname">
                                </mat-form-field>
                                <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="closeActiveRow(cashFlowLeft.cashflowtypeid, 'EDIT');">
                                    <i class="fa-regular fa-xmark"></i>
                                </button>
                                <button mat-button class="button-text bal-sheet-icon" (click)="updateActiveRow('EDIT');">
                                    <i class="fa-regular fa-check done-icn"></i>
                                </button>
                              </div>
                            </div>
                            <div class="amount flex-box-vc-hr"
                                 title="{{(new.amount == null || new.amount == '0' || new.amount == '0.00') ? '-' : new.amount}}">
                              <div class="sheet-editable">
                                <p class="ellipse no-marg">
                                  {{(new.amount == null || new.amount == '0' || new.amount == '0.00') ? '-' : new.amount}}
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #notEditable>
                            <div class="desc" title="{{new.cashflowlineitem}}">
                              <p class="ellipse no-marg">{{new.cashflowlineitem}}</p>
                            </div>
                            <div class="amount flex-box-vc-hr"
                                 title="{{(new.amount == null || new.amount == '0' || new.amount == '0.00') ? '-' : new.amount}}">
                              <p class="ellipse no-marg">
                                {{(new.amount == null || new.amount == '0' || new.amount == '0.00') ? '-' : new.amount}}
                              </p>
                            </div>
                          </ng-template>
                        </div>
                      </li>
                      <!-- Active row -->
                      <li *ngIf="isActiveNewRow && cashFlowLeft.cashflowtypeid === leftSideCashFlowTypeId">
                        <div class="left-child-row">
                          <div class="hover-items"></div>
                          <div class="desc">
                            <div class="sheet-editable">
                              <mat-form-field class="sheet-form-field">
                                <input matInput class="sheet-textfield" [(ngModel)]="cashLineItemname"
                                       title="{{cashLineItemname}}">
                              </mat-form-field>
                                <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="closeActiveRow(cashFlowLeft.cashflowtypeid, 'ADD');">
                                    <i class="fa-regular fa-xmark"></i>
                                </button>
                                <button mat-button class="button-text bal-sheet-icon" title="Update" (click)="updateActiveRow('ADD');">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                            </div>
                          </div>
                          <div class="amount flex-box-vc-hr">
                            <div class="sheet-editable">
                              <p class="ellipse no-marg">-</p>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!--total row-->
                      <li *ngFor="let total of cashFlowLeft.total">
                        <div class="left-child-row total-row">
                          <div class="status">
                            <span class="col-cf-status">
                            </span>
                          </div>
                          <div class="hover-items"></div>
                          <div class="desc">
                            <p class="ellipse no-marg">{{total.cashflowlineitem}}</p>
                          </div>
                          <div class="amount flex-box-vc-hr"
                               title="{{total.amount == 0 || total.amount == 0.00 ||  total.amount == null ? '-' : total.amount }}">
                            <p class="ellipse no-marg">
                              {{total.amount == 0 || total.amount == 0.00 ||  total.amount == null ? '-' : total.amount }}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="left-child-row">
                          <div class="desc">
                            <p class="ellipse no-marg"></p>
                          </div>
                          <div class="amount flex-box-vc-hr">
                            <p class="ellipse no-marg"></p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="last-child-row">
                <div class="desc">
                  <p class="ellipse no-marg"></p>
                </div>
                <div class="amount flex-box-vc-hr">
                  <p class="ellipse no-marg"></p>
                </div>
              </div>

              <div class="last-child-row">
                <div class="desc">
                  <p class="ellipse no-marg" title="{{netAmountName}}">{{netAmountName}}</p>
                </div>
                <div class="amount flex-box-vc-hr">
                  <p class="ellipse no-marg"
                     title="{{netAmount == '0' || netAmount == '0.00' || netAmount == null ? '-' : netAmount}}">
                    {{netAmount == '0' || netAmount == '0.00' || netAmount == null ? '-' : netAmount}}
                  </p>
                </div>
              </div>
            </div>

          </div>
          <div class="cf-work-sheet-container-body-details-right">
            <ul class="cust-items">
              <li *ngFor="let middle of cashFlowMiddleData">
                <div class="cf-work-sheet-container-body-details-items assets">
                  <div class="cf-work-sheet-container-body-details-items-header">
                    <p class="ellipse no-marg" title="{{middle.fingroupname}}">{{middle.fingroupname}}</p>
                  </div>
                  <div class="cf-work-sheet-container-body-details-items-subheader">
                    <ng-container *ngFor="let lead of middle.leadsheetnames; index as i">
                      <div class="col-subheader flex-box-vc-hr" title="{{lead.leadsheetname}}">
                        {{lead.leadsheetname}}
                      </div>
                    </ng-container>
                  </div>
                  <div class="cf-work-sheet-container-body-details-items-details">
                    <ul class="cust-items">
                      <li class="first">
                        <ng-container *ngFor="let camt of middle.currentamount">
                          <div class="col-details flex-box-vc-hr"
                               title="{{camt.currentamount == '0' || camt.currentamount == '0.00' || camt.currentamount == null ? '-' : camt.currentamount}}">
                            <p class="ellipse no-marg">
                              {{camt.currentamount == '0' || camt.currentamount == '0.00' || camt.currentamount == null ? '-' : camt.currentamount}}
                            </p>
                          </div>
                        </ng-container>
                      </li>
                      <!-- </ng-container> -->
                      <li class="second">
                        <ng-container *ngFor="let pamt of middle.previousamount">
                          <div class="col-details flex-box-vc-hr"
                               title="{{pamt.previousamount == '0' || pamt.previousamount == '0.00' || pamt.previousamount == null ? '-' : pamt.previousamount}}">
                            <p class="ellipse no-marg">
                              {{pamt.previousamount == '0' || pamt.previousamount == '0.00' || pamt.previousamount == null ? '-' : pamt.previousamount}}
                            </p>
                          </div>
                        </ng-container>
                      </li>
                      <li class="total">
                        <ng-container *ngFor="let tamt of middle.total">
                          <div class="col-details flex-box-vc-hr"
                               title="{{tamt.total == '0' || tamt.total == '0.00' || tamt.total == null ? '-' : tamt.total}}">
                            <p class="ellipse no-marg">
                              {{tamt.total == '0' || tamt.total == '0.00' || tamt.total == null ? '-' : tamt.total}}
                            </p>
                          </div>
                        </ng-container>
                      </li>
                      <ng-container *ngFor="let cash of middle.CFO.childs; index as i;">
                        <ng-container *ngIf="cash.addcashflowid == 0; else newcfo">
                          <li>
                            <ng-container *ngFor="let cfoRight of cash.leadsheet;">
                              <ng-container *ngIf="isFocusOldMiddleRow && cash.cashflowlineitemid === cashFlowLineItemId && cfoRight.leadsheetid === middleLeadsheetId; else cfoOldFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('OLD', cash.cashflowlineitemid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('OLD', cash.cashflowlineitemid, cfoRight.tbcashflowamountchangeid, cfoRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cfoOldFocusBox>
                                <ng-container *ngIf="cfoRight.tbcashflowismodified == 1 else cfoOldNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cfoRight.oldamount == '0' || cfoRight.oldamount == '0.00' || cfoRight.oldamount == null ? '-' : cfoRight.oldamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1; cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cash.cashflowlineitemid
                                , cfoRight.leadsheetid, cfoRight.oldamount);">
                                      {{cfoRight.oldamount == '0' || cfoRight.oldamount == '0.00' || cfoRight.oldamount == null ? '-' : cfoRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cfoOldNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cfoRight.oldamount == '0' || cfoRight.oldamount == '0.00' || cfoRight.oldamount == null ? '-' : cfoRight.oldamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1; cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cash.cashflowlineitemid
                                , cfoRight.leadsheetid, cfoRight.oldamount);">
                                      {{cfoRight.oldamount == '0' || cfoRight.oldamount == '0.00' || cfoRight.oldamount == null ? '-' : cfoRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-container>
                        <ng-template #newcfo>
                          <li>
                            <ng-container *ngFor="let cfoRight of cash.leadsheet; let i = index;">
                              <!-- <ng-container *ngIf="isFocusNewMiddleRow && cash.addcashflowid === addCashFlowId && cfoRight.leadsheetid === middleLeadsheetId; else cfoNewFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                              <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('NEW', cash.addcashflowid)">
                                <i class="fa-regular fa-xmark"></i>
                            </button>
                              <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('NEW', cash.addcashflowid, cfoRight.addcashflowamountid, cfoRight.leadsheetid)">
                                <i class="fa-regular fa-check"></i>
                            </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cfoNewFocusBox>
                                <ng-container *ngIf="cfoRight.addcashflowismodified == 1 else cfoNewNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cfoRight.newamount == '0' || cfoRight.newamount == '0.00' || cfoRight.newamount == null ? '-' : cfoRight.newamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cash.addcashflowid, cfoRight.leadsheetid, cfoRight.newamount);">
                                      {{cfoRight.newamount == '0' || cfoRight.newamount == '0.00' || cfoRight.newamount == null ? '-' : cfoRight.newamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cfoNewNotModified> -->
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cfoRight.newamount == '0' || cfoRight.newamount == '0.00' || cfoRight.newamount == null ? '-' : cfoRight.newamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;">
                                      {{cfoRight.newamount == '0' || cfoRight.newamount == '0.00' || cfoRight.newamount == null ? '-' : cfoRight.newamount}}
                                    </p>
                                  </div>
                                <!-- </ng-template> -->
                              <!-- </ng-template> -->
                            </ng-container>
                          </li>
                        </ng-template>
                      </ng-container>
                      <li *ngIf="isActiveNewRow && middle.CFO.cashflowtypeid === leftSideCashFlowTypeId">
                        <ng-container *ngFor="let c of middle.CFO.childs[0].leadsheet; let i = index;">
                          <div class="col-details">
                            <p class="ellipse no-marg" style="text-align: right;">-</p>
                          </div>
                        </ng-container>
                      </li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <ng-container *ngFor="let cwca of middle.CFWCA.childs; index as i;">
                        <ng-container *ngIf="cwca.addcashflowid == 0; else newcwca">
                          <li>
                            <ng-container *ngFor="let cwcaRight of cwca.leadsheet">
                              <ng-container *ngIf="isFocusOldMiddleRow && cwca.cashflowlineitemid === cashFlowLineItemId && cwcaRight.leadsheetid === middleLeadsheetId; else cwcaOldFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('OLD', cwca.cashflowlineitemid)">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                    <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('OLD', cwca.cashflowlineitemid, cwcaRight.tbcashflowamountchangeid, cwcaRight.leadsheetid)">
                                        <i class="fa-regular fa-check"></i>
                                    </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cwcaOldFocusBox>
                                <ng-container *ngIf="cwcaRight.tbcashflowismodified == 1 else cwcaOldNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cwcaRight.oldamount == '0' || cwcaRight.oldamount == '0.00' || cwcaRight.oldamount == null ? '-' : cwcaRight.oldamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cwca.cashflowlineitemid, cwcaRight.leadsheetid, cwcaRight.oldamount);">
                                      {{cwcaRight.oldamount == '0' || cwcaRight.oldamount == '0.00' || cwcaRight.oldamount == null ? '-' : cwcaRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cwcaOldNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cwcaRight.oldamount == '0' || cwcaRight.oldamount == '0.00' || cwcaRight.oldamount == null ? '-' : cwcaRight.oldamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cwca.cashflowlineitemid, cwcaRight.leadsheetid, cwcaRight.oldamount);">
                                      {{cwcaRight.oldamount == '0' || cwcaRight.oldamount == '0.00' || cwcaRight.oldamount == null ? '-' : cwcaRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-container>
                        <ng-template #newcwca>
                          <li>
                            <ng-container *ngFor="let cwcaRight of cwca.leadsheet">
                              <ng-container *ngIf="isFocusNewMiddleRow && cwca.addcashflowid === addCashFlowId && cwcaRight.leadsheetid === middleLeadsheetId; else cwcaNewFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('NEW', cwca.addcashflowid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('NEW', cwca.addcashflowid, cwcaRight.addcashflowamountid, cwcaRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cwcaNewFocusBox>
                                <ng-container *ngIf="cwcaRight.addcashflowismodified == 1 else cwcaNewNotModified">
                                  <div class="col-details flex-box-vc-hr modified" title="{{cwcaRight.newamount == '0' || cwcaRight.newamount == '0.00' || cwcaRight.newamount == null
                                ? '-' : cwcaRight.newamount}}" matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cwca.addcashflowid, cwcaRight.leadsheetid, cwcaRight.newamount);">
                                      {{
cwcaRight.newamount == '0' || cwcaRight.newamount == '0.00' || cwcaRight.newamount == null
                                   ? '-' : cwcaRight.newamount
                                      }}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cwcaNewNotModified>
                                  <div class="col-details flex-box-vc-hr" title="{{cwcaRight.newamount == '0' || cwcaRight.newamount == '0.00' || cwcaRight.newamount == null
                                ? '-' : cwcaRight.newamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cwca.addcashflowid, cwcaRight.leadsheetid, cwcaRight.newamount);">
                                      {{
cwcaRight.newamount == '0' || cwcaRight.newamount == '0.00' || cwcaRight.newamount == null
                                   ? '-' : cwcaRight.newamount
                                      }}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-template>
                      </ng-container>
                      <li *ngIf="isActiveNewRow && middle.CFWCA.cashflowtypeid === leftSideCashFlowTypeId">
                        <ng-container *ngFor="let c of middle.CFWCA.childs[0].leadsheet">
                          <div class="col-details">
                            <p class="ellipse no-marg" style="text-align: right;">-</p>
                          </div>
                        </ng-container>
                      </li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <ng-container *ngFor="let cff of middle.CFF.childs; index as i;">
                        <ng-container *ngIf="cff.addcashflowid == 0; else newcff">
                          <li>
                            <ng-container *ngFor="let cffRight of cff.leadsheet">
                              <ng-container *ngIf="isFocusOldMiddleRow && cff.cashflowlineitemid === cashFlowLineItemId && cffRight.leadsheetid === middleLeadsheetId; else cffOldFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('OLD', cff.cashflowlineitemid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('OLD', cff.cashflowlineitemid, cffRight.tbcashflowamountchangeid, cffRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cffOldFocusBox>
                                <ng-container *ngIf="cffRight.tbcashflowismodified == 1 else cffOldNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cffRight.oldamount == '0' || cffRight.oldamount == '0.00' || cffRight.oldamount == null ? '-' : cffRight.oldamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cff.cashflowlineitemid, cffRight.leadsheetid, cffRight.oldamount);">
                                      {{cffRight.oldamount == '0' || cffRight.oldamount == '0.00' || cffRight.oldamount == null ? '-' : cffRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cffOldNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cffRight.oldamount == '0' || cffRight.oldamount == '0.00' || cffRight.oldamount == null ? '-' : cffRight.oldamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cff.cashflowlineitemid, cffRight.leadsheetid, cffRight.oldamount);">
                                      {{cffRight.oldamount == '0' || cffRight.oldamount == '0.00' || cffRight.oldamount == null ? '-' : cffRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-container>
                        <ng-template #newcff>
                          <li>
                            <ng-container *ngFor="let cffRight of cff.leadsheet">
                              <ng-container *ngIf="isFocusNewMiddleRow && cff.addcashflowid === addCashFlowId && cffRight.leadsheetid === middleLeadsheetId; else cffNewFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('NEW', cff.addcashflowid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('NEW', cff.addcashflowid, cffRight.addcashflowamountid, cffRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cffNewFocusBox>
                                <ng-container *ngIf="cffRight.addcashflowismodified == 1 else cffNewNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cffRight.newamount == '0' || cffRight.newamount == '0.00' || cffRight.newamount == null ? '-' : cffRight.newamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cff.addcashflowid, cffRight.leadsheetid, cffRight.newamount);">
                                      {{cffRight.newamount == '0' || cffRight.newamount == '0.00' || cffRight.newamount == null ? '-' : cffRight.newamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cffNewNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cffRight.newamount == '0' || cffRight.newamount == '0.00' || cffRight.newamount == null ? '-' : cffRight.newamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cff.addcashflowid, cffRight.leadsheetid, cffRight.newamount);">
                                      {{cffRight.newamount == '0' || cffRight.newamount == '0.00' || cffRight.newamount == null ? '-' : cffRight.newamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-template>
                      </ng-container>
                      <li *ngIf="isActiveNewRow && middle.CFF.cashflowtypeid === leftSideCashFlowTypeId">
                        <ng-container *ngFor="let c of middle.CFF.childs[0].leadsheet">
                          <div class="col-details">
                            <p class="ellipse no-marg" style="text-align: right;">-</p>
                          </div>
                        </ng-container>
                      </li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <ng-container *ngFor="let cfi of middle.CFI.childs; index as i;">
                        <ng-container *ngIf="cfi.addcashflowid == 0; else newcfi">
                          <li>
                            <ng-container *ngFor="let cfiRight of cfi.leadsheet">
                              <ng-container *ngIf="isFocusOldMiddleRow && cfi.cashflowlineitemid === cashFlowLineItemId && cfiRight.leadsheetid === middleLeadsheetId; else cfiOldFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('OLD', cfi.cashflowlineitemid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('OLD', cfi.cashflowlineitemid, cfiRight.tbcashflowamountchangeid, cfiRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cfiOldFocusBox>
                                <ng-container *ngIf="cfiRight.tbcashflowismodified == 1 else cfiOldNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cfiRight.oldamount == '0' || cfiRight.oldamount == '0.00' || cfiRight.oldamount == null ? '-' : cfiRight.oldamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cfi.cashflowlineitemid, cfiRight.leadsheetid, cfiRight.oldamount);">
                                      {{cfiRight.oldamount == '0' || cfiRight.oldamount == '0.00' || cfiRight.oldamount == null ? '-' : cfiRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cfiOldNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cfiRight.oldamount == '0' || cfiRight.oldamount == '0.00' || cfiRight.oldamount == null ? '-' : cfiRight.oldamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('OLD', cfi.cashflowlineitemid, cfiRight.leadsheetid, cfiRight.oldamount);">
                                      {{cfiRight.oldamount == '0' || cfiRight.oldamount == '0.00' || cfiRight.oldamount == null ? '-' : cfiRight.oldamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-container>
                        <ng-template #newcfi>
                          <li>
                            <ng-container *ngFor="let cfiRight of cfi.leadsheet">
                              <ng-container *ngIf="isFocusNewMiddleRow && cfi.addcashflowid === addCashFlowId && cfiRight.leadsheetid === middleLeadsheetId; else cfiNewFocusBox">
                                <div class="col-details flex-box-vc-hr">
                                  <div class="sheet-editable">
                                    <mat-form-field class="sheet-form-field"
                                                    style="position: relative; z-index: 0;text-align: right">
                                      <input matInput class="sheet-textfield" [(ngModel)]="cfoAmount" autofocus
                                             (keypress)="onlyNumberKey($event)" title="Only Numbers Allowed!">
                                    </mat-form-field>
                                    <button mat-button class="button-text bal-sheet-icon" title="Close" (click)="close('NEW', cfi.addcashflowid)">
                                      <i class="fa-regular fa-xmark"></i>
                                  </button>
                                  <button mat-button class="button-text bal-sheet-icon" title="Close" title="{{cfoAmount == '0' || cfoAmount == '0.00' || cfoAmount == null ? 'Add' : 'Update'}}" (click)="saveMiddleAmount('NEW', cfi.addcashflowid, cfiRight.addcashflowamountid, cfiRight.leadsheetid)">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #cfiNewFocusBox>
                                <ng-container *ngIf="cfiRight.addcashflowismodified == 1 else cfiNewNotModified">
                                  <div class="col-details flex-box-vc-hr modified"
                                       title="{{cfiRight.newamount == '0' || cfiRight.newamount == '0.00' || cfiRight.newamount == null ? '-' : cfiRight.newamount}}"
                                       matTooltip='Entry Modified' matTooltipPosition='above'
                                       matTooltipClass='entry-modified' color='primary'>
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cfi.addcashflowid, cfiRight.leadsheetid, cfiRight.newamount);">
                                      {{cfiRight.newamount == '0' || cfiRight.newamount == '0.00' || cfiRight.newamount == null ? '-' : cfiRight.newamount}}
                                    </p>
                                  </div>
                                </ng-container>
                                <ng-template #cfiNewNotModified>
                                  <div class="col-details flex-box-vc-hr"
                                       title="{{cfiRight.newamount == '0' || cfiRight.newamount == '0.00' || cfiRight.newamount == null ? '-' : cfiRight.newamount}}">
                                    <p class="ellipse no-marg"
                                       style="width: 100%; text-align: right; position: relative;z-index: 1;cursor: pointer;"
                                       (click)="activeMiddleRow('NEW', cfi.addcashflowid, cfiRight.leadsheetid, cfiRight.newamount);">
                                      {{cfiRight.newamount == '0' || cfiRight.newamount == '0.00' || cfiRight.newamount == null ? '-' : cfiRight.newamount}}
                                    </p>
                                  </div>
                                </ng-template>
                              </ng-template>
                            </ng-container>
                          </li>
                        </ng-template>
                      </ng-container>
                      <li *ngIf="isActiveNewRow && middle.CFI.cashflowtypeid === leftSideCashFlowTypeId">
                        <ng-container *ngFor="let c of middle.CFI.childs[0].leadsheet">
                          <div class="col-details">
                            <p class="ellipse no-marg" style="text-align: right;">-</p>
                          </div>
                        </ng-container>
                      </li>
                      <li></li>
                      <li></li>
                      <li class="final-total">
                        <ng-container *ngFor="let bottomTotal of middle.bottomtotal">
                          <div class="col-details flex-box-vc-hr"
                               title="{{bottomTotal.total == '0' || bottomTotal.total == '0.00' || bottomTotal.total == null ? '-' : bottomTotal.total}}">
                            <p class="ellipse no-marg">
                              {{bottomTotal.total == '0' || bottomTotal.total == '0.00' || bottomTotal.total == null ? '-' : bottomTotal.total}}
                            </p>
                          </div>
                        </ng-container>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- preview section starts here from UI -->
  <div class="cf-work-sheet-container-aside">

    <div class="cf-work-sheet-container-aside-header">
      <div class="cf-work-sheet-container-aside-header-title">
        <h3>Preview</h3>
      </div>
      <div class="cf-work-sheet-container-aside-header-content">
        <button mat-button type="button" title="Refresh" class="button-text stroked-btn transparent-btn" (click)="refresh('RIGHT')">
            <i class="fa-regular fa-arrows-rotate"></i>
        </button>
        <!-- <button type="button" mat-flat-button class="save-button" color="primary">Save</button> -->
      </div>
    </div>
    <div class="cf-work-sheet-container-aside-body">
      <ng-container *ngFor="let cash of cashFlowData">
        <div class="cf-work-sheet-container-aside-body-headerdetails">
          <div class="col-groupname flex-box-vc-hl">
            <p class="ellipse no-marg">group name</p>
          </div>
          <div class="col-dateyear flex-box-vc-hr">
            <p class="ellipse no-marg" title="{{cash.date | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">{{cash.date | appCountableTimeZone:'MMMM d yyyy':'UTC'}}</p>
          </div>
          <ng-container *ngFor="let clt of cash.cashflowtype; index as i;">
            <div [ngClass]="{'col-cfo': i==0, 'col-cfi':i==1, 'col-cff':i==2, 'col-not-applicable' :i==3}">
              <p class="ellipse no-marg" title="{{clt.cashflowtypecode}}">{{clt.cashflowtypecode}}</p>
            </div>
          </ng-container>
        </div>
        <div class="cf-work-sheet-container-aside-body-content">
          <!-- Assets Expansion panel -->
          <mat-accordion multi="true">
            <!-- 1st expansion panel -->
            <ng-container *ngFor="let gr of cash.group">
              <mat-expansion-panel *ngFor="let sg of gr.subgroup" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="cash-flow-wrapper">
                      <div class="col-currentasset flex-box-vc-hl">
                        <p class="ellipse no-marg" title="{{sg.finsubgroupname}}">{{sg.finsubgroupname}}</p>
                      </div>
                      <div class="col-yearamt flex-box-vc-hr">
                        <p class="ellipse no-marg" title="{{sg.finalamount}}">{{sg.finalamount}}</p>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="cash-flow-wrapper-content">
                  <ul>
                    <li *ngFor="let ssg of sg.tbrecords">
                      <div class="col-grp-name flex-box-vc-hl">
                        <p class="ellipse no-marg" title="{{ssg.accountname}}">{{ssg.accountname}}</p>
                      </div>
                      <div class="col-year-amt flex-box-vc-hr">
                        <p class="ellipse no-marg" title="{{ssg.finalamount}}">{{ssg.finalamount}}</p>
                      </div>
                      <div class="cash-flow-radio-button">
                        <ul>
                          <li *ngFor="let cft of ssg.cashflowtype; let i = index;">
                            <!-- {{cft | json}} -->

                            <ng-container>

                              <input matInput [hidden]="true" [(ngModel)]="trailbalanceid"
                                     value="{{cft.trailbalanceid}}" #trailbalance="ngModel">
                              <input matInput [hidden]="true" [(ngModel)]="tbcashflowid" value="{{cft.tbcashflowid}}"
                                     #tbcashflow="ngModel">
                              <mat-radio-button name="{{ssg.trailbalanceid}}" id="{{ssg.trailbalanceid+'-'+i}}"
                                                [value]="cft.cashflowtypeid" [checked]="cft.ischecked == 1 ? true : false"
                                                (change)="savePreviewCashFlow($event, cft.trailbalanceid, cft.tbcashflowid)">
                              </mat-radio-button>{{tbcashflowid}}
                            </ng-container>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </mat-expansion-panel>
              <div class="cash-flow-wrapper-footersection">
                <div class="col-totalasset flex-box-vc-hl">
                  <p class="ellipse no-marg asset-color" title="{{gr.fingroupname}}">{{gr.fingroupname}}</p>
                </div>
                <div class="col-totalyearamt flex-box-vc-hr">
                  <p class="ellipse no-marg" title="{{gr.finalamount}}">{{gr.finalamount}}</p>
                </div>
              </div>
            </ng-container>
          </mat-accordion>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #confirmDelete>
  <div class="pd-dialog-delete">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
            <i class="fa-regular fa-triangle-exclamation warning-msg"></i>
          <span>Confirmation</span>
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close]>
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">{{confirmMessage}}</p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary" [mat-dialog-close]
                (click)="close()">No</button>
        <button mat-flat-button class="float-right yesno-btn" color="primary" [mat-dialog-close]
                (click)="updateActiveRow('DELETE')">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>
